module.exports = __webpack_public_path__ + "static/media/iPhone16.343279c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/banner-carousel/new-banner/iPhone16.png
// module id = 525
// module chunks = 0